import { render, staticRenderFns } from "./DepositoShowData.vue?vue&type=template&id=00b8deb0&scoped=true&"
import script from "./DepositoShowData.vue?vue&type=script&lang=js&"
export * from "./DepositoShowData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b8deb0",
  null
  
)

export default component.exports